export default __webpack_public_path__ + "static/media/BillingProfileAvtar.0d4e5bf9.png";